import type React from 'react';

import { Text } from '@change/ds-core-ui';

type Props = {
	label: string;
	qaSelectorLabel: string;
};

export const Label: React.FC<Props> = ({ qaSelectorLabel, label }) => {
	return (
		<Text as="h2" size="medium" fontWeight="bold" data-qa={qaSelectorLabel}>
			{label}
		</Text>
	);
};
